import alemania from "../assets/flags/alemania.png";
import belgica from "../assets/flags/belgica.png";
import canada from "../assets/flags/canada.png";
import chile from "../assets/flags/chile.png";
import ecuador from "../assets/flags/ecuador.png";
import espana from "../assets/flags/espana.png";
import francia from "../assets/flags/francia.png";
import usa from "../assets/flags/usa.png";

export const seminarsData = [
  {
    country: "Francia",
    flag: francia,
    programs: [
      { 
        title: "Maestrías: Viviana Gavilanes",
        link: "https://drive.google.com/uc?export=download&id=1d2xupnDKaaWAUvqUfL4bRdZa6F7Y_H7o",
      },
      { 
        title: "Doctorados: Katherine Morales",
        link: "https://drive.google.com/uc?export=download&id=1HvrG1lej5r0k710cq2wl7QYPmJOQyfty",
      },
    ]
  },
  {
    country: "Alemania",
    flag: alemania,
    programs: [
      { 
        title: "Doctorados: Maribel Montenegro",
        link: "https://drive.google.com/uc?export=download&id=1TK7RzjgxsESTrTR4PJ7N2gH0pBvQ6PDO",
      },
      { 
        title: "Doctorados: Jorge Luis Chicaiza",
        link: "https://drive.google.com/uc?export=download&id=1jPQIGhJ1vSBR1aypEyNnjQrcZvokPdTh",
      },
    ]
  },
  {
    country: "Estados Unidos",
    flag: usa,
    programs: [
      { 
        title: "Doctorados: Roberto Torres",
        link: "https://drive.google.com/uc?export=download&id=1lp_wAipdkn5QkWhE8HUZUC1RFjcDyEwt",
      },
    ]
  },
  {
    country: "Chile",
    flag: chile,
    programs: [
      { 
        title: "Maestrías: Carlos Ajila",
        link: "https://drive.google.com/uc?export=download&id=1Qy2oCIbsN62V4OUkVbtWdNfKx_oezHWM",
      },
      { 
        title: "Doctorados: Cristian Núñez",
        link: "https://drive.google.com/uc?export=download&id=1mra5hSN54BuaQ1mj15oJ5aWfrIbJ5Cb7",
      },
    ]
  },
  {
    country: "Canada",
    flag: canada,
    programs: [
      { 
        title: "Doctorados: Leonardo Montoya",
        link: "https://drive.google.com/uc?export=download&id=1AkFh6H30P1TzfO53p33i9VCwdCMwB1HE",
      },
    ]
  },
  {
    country: "Bélgica",
    flag: belgica,
    programs: [
      { 
        title: "Maestrías - Doctorados: Andrea García",
        link: "https://drive.google.com/uc?export=download&id=1JBHnmF09OVy41IkHDRtXwdMGSarhLUib",
      },
    ]
  },
  {
    country: "Ecuador",
    flag: ecuador,
    programs: [
      { 
        title: "Maestrías: Paola Quiloango",
        link: "https://drive.google.com/uc?export=download&id=1beKKPk5azJn5pWCeJPVyebkd7myBE84B",
      },
      { 
        title: "Doctorados: Paula Castro",
        link: "https://drive.google.com/uc?export=download&id=1KHcB_nhu2HOfwtqGe7SwCpzV9dpEWQhL",
      },
    ]
  },
  {
    country: "España",
    flag: espana,
    programs: [
      { 
        title: "Maestrías: Alex Pérez",
        link: "https://drive.google.com/uc?export=download&id=11Er0M4NJwVz6lPYQPJbGjzG71Hx5HGXu",
      },
      { 
        title: "Maestrías - Doctorados: Miguel Flores",
        link: "https://drive.google.com/uc?export=download&id=1CPXemVX3CZXLUt2N4THkAY3Xj-vBN_ro",
      },
    ]
  },
];